export default __webpack_public_path__ + "static/media/sua.776afe0b.png";